<template>
    <div 
        :class="['fs5-btn', this.btnClass, this.textTransform, disabled ? 'disabled' : '']"
        @click="emitClick"
    >
        <img 
            v-if="icon !== undefined && icon !== null && icon.trim() != '' " 
            :src="icon"
        />
        <span v-html="label"></span>
        <span v-if="isNew" :class="['fs5-badge', this.isNewClass]"> {{ t.new }}</span>        
    </div>
</template>

<script>
    export default {
        name: 'fs5-button',
        data() {
            return {
                t: this.translations,
            }
        },
        props: {
            btnType: {
                type: String,
                default: ''
            },
            textTransformType: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: 'example'
            },
            icon: {
                type: String
            },
            disabled: {
                type: Boolean,
                default: false
            },
            isNew : {
                type: Boolean,
                default: false
            },
            translations : {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        methods: {
            emitClick() {
                this.$emit('clicked')
            }
        },
        computed: {
            btnClass(){
                let btnClass = '';
                switch(this.btnType){
                    case 'primary':
                        btnClass = 'fs5-btn-blue';
                        break;
                    case 'white':
                        btnClass = 'fs5-btn-white';
                        break;
                    case 'white2':
                        btnClass = 'fs5-btn-white2';
                        break;
                    case 'orange':
                        btnClass = 'fs5-btn-orange';
                        break;
                    default:
                        btnClass = 'fs5-btn-default';
                        break;
                }
                return btnClass
            },
            textTransform() {
                let textTransform = '';
                switch(this.textTransformType){
                    case 'uppercase':
                        textTransform = 'uppercase';
                        break;
                    case 'lowercase':
                        textTransform = 'lowercase';
                        break;
                    case 'capitalize':
                        textTransform = 'capitalize';
                        break;
                    default:
                        textTransform = '';
                        break;
                }
                return textTransform
            },
            isNewClass(){
                let isNewClass = '';
                switch(this.btnType){
                    case 'primary':
                        isNewClass = 'white';
                        break;
                    case 'white':
                        isNewClass = 'blue';
                        break;
                    default:
                        isNewClass = 'blue';
                        break;
                }
                return isNewClass
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-btn{
        font-family: $fs5-font2!important;
        font-size: 0.875rem!important; // 14px 
        line-height: 1.2!important;
        font-weight: 700!important;
        text-align: center;

        border-radius: 0.285714286em; // 4px
        padding: 1.428571429em 2.857142857em;

        transition: all 0.5s ease-out;

        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 0.714285714em;

        span{
            font: inherit;
        }
        img{
            font: inherit;
            height: 1.428571429em;
            width: auto;
        }

        &.disabled{
            opacity: 0.5;
            &:hover{
                cursor: not-allowed;
            }
        }
        &:hover{
            cursor: pointer;
        }
        &.fs5-btn-default{
            color: $fs5-color5!important;
            background-color: $fs5-color6!important;
            &:hover{
                box-shadow: 0px 4px 11px $fs5-color7;
            }
        }
        &.fs5-btn-blue{
            color: $fs5-color2!important;
            background-color: $fs5-color5!important;
            &:hover{
                box-shadow: 0px 4px 11px $fs5-color8;
            }
        }
        &.fs5-btn-white{
            color: $fs5-color11!important;
            border: 1px $fs5-color1 solid!important;
            background-color: $fs5-color2!important;
            &:hover{
                box-shadow: 0px 4px 11px $fs5-color14;
            }
        }
        &.fs5-btn-white2{
            color: $fs5-color5!important;
            border: 1px $fs5-color5 solid!important;
            background-color: $fs5-color2!important;
            &:hover{
                box-shadow: 0px 4px 11px $fs5-color8;
            }
        }
        &.fs5-btn-orange{
            color: $fs5-color2!important;
            background-color: $fs5-color12!important;
            &:hover{
                box-shadow: 0px 4px 11px $fs5-color13;
            }
        }
        &.capitalize{
            text-transform: capitalize;
        }
        &.uppercase{
            text-transform: uppercase;
        }
        &.lowercase{
            text-transform: lowercase;
        }
    }
    .fs5-badge {
        border-radius: 2px !important;
        text-align: center !important;
        font-size: 0.65em !important; 
        font-weight: 900 !important;
        padding: 0.35em !important;
        font-family: Lato !important;
        
        &.blue{
            background-color: #0F7BFF;
            color: #ffffff;
        }

        &.white {
            background-color: #ffffff;
            color: #0F7BFF;
        }
    }

</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/tools/button/Button.vue